import {
  SET_FULL_SCREEN_TOGGLE,
  SET_MENU_TOGGLE,
  SET_FULL_VW,
  SET_BREAD_CRUMB_STATUS,
  SET_MENU_TABS,
  SET_ACTION_TAB,
  SET_ASIDEMENULIST,
  SET_BRABNS,
} from "../mutation_type";

const state = {
  menuSwitch: true, // 菜单开关
  fullScreenSwitch: false, // 全屏开关
  breadcrumbSwitch: false, // 面包屑导航尾部自定义标题开关
  breadcrumbContent: "", // 面包屑导航尾部自定义标题
  vw: window.innerWidth - 220, // 列表区域宽度
  menuTabs: [], // tabs选项卡
  actionTab: "", //当前活动TAB
  asideMenuList: {}, // 左侧菜单权限列表
  globalBrands: [], // 品牌列表
};

const getters = {
  getMenuSwitch: (state) => state.menuSwitch,
  getFullScreenSwitch: (state) => state.fullScreenSwitch,
  getMainTableWidth: (state) => state.vw,
  getBreadcrumbSwitch: (state) => state.breadcrumbSwitch,
  getBreadcrumbContent: (state) => state.breadcrumbContent,
  getMenuTabs: (state) => state.menuTabs,
  getActionTab: (state) => state.actionTab,
  getAsideMenuList: (state) => state.asideMenuList,
};

const mutations = {
  [SET_FULL_SCREEN_TOGGLE]() {
    state.fullScreenSwitch = !state.fullScreenSwitch;
    if (state.fullScreenSwitch) {
      state.vw = window.innerWidth;
    } else {
      state.vw = window.innerWidth - 220;
    }
    window.dispatchEvent(new Event("resize"));
  },
  [SET_MENU_TOGGLE](state) {
    state.menuSwitch = !state.menuSwitch;
  },
  [SET_FULL_VW]() {
    if (state.fullScreenSwitch) {
      state.vw = window.innerWidth;
    } else {
      state.vw = window.innerWidth - 220;
    }
  },
  [SET_BREAD_CRUMB_STATUS](state, status) {
    state.breadcrumbSwitch = status.breadcrumbSwitch;
    state.breadcrumbContent = status.breadcrumbContent;
  },
  [SET_MENU_TABS](state, status) {
    state.menuTabs = status;
  },
  [SET_ACTION_TAB](state, status) {
    state.actionTab = status;
  },
  [SET_ASIDEMENULIST](state, data) {
    state.asideMenuList = data;
  },
  [SET_BRABNS](state, data) {
    state.globalBrands = data;
  },
};

export default {
  state,
  getters,
  mutations,
};
